import type {Nullable} from "../bootstrap/common/types";

export type GlobalWindow = typeof globalThis;

export class Globals {

    public visualViewport(): Nullable<VisualViewport> {
        return window.visualViewport;
    }

    public window(): GlobalWindow {
        return globalThis;
    }

    public navigator(): Navigator {
        return navigator;
    }

    public document(): Document {
        return document;
    }

    public bodyElement(): HTMLElement {
        return document.body;
    }

    public headElement(): HTMLElement {
        return document.head;
    }

    public htmlElement(): HTMLElement {
        return document.documentElement;
    }

    public documentReferrer(): string {
        return document.referrer;
    }

    public documentBaseUri(): string {
        return document.baseURI;
    }

    public activeElement(): Nullable<Element> {
        return document.activeElement;
    }

    public browserWideSpeechSynthesis(): SpeechSynthesis {
        return window.speechSynthesis;
    }
}

export const GLOBAL = new Globals();